import React, { useEffect } from 'react'
import { useSelector } from 'react-redux'
import { MfRouteComponentLoader } from 'shared/helpers/mf-component-loader'
import { IAppState } from 'core/store/store'
import PageNotFound from 'secure-pages/page-not-found/PageNotFound'
import { Spinner } from '@digicert/dcone-common-ui'
import { useLocalStorageUrl } from 'shared/helpers/useLocalStorageUrl'

const ECOMMERCE_FALLBACK = 'https://app.digicert.com'
const ECOMMERCE_LS_KEY = 'ecommerce_domain_url'
const ONELOGIN_MFE_SESSION_KEY = 'ol_mfe_source'
const ONELOGIN_MFE_SESSION_VALUE = 'onelogin'

function useEcommerceDomain(): string {
  return useLocalStorageUrl(ECOMMERCE_LS_KEY, ECOMMERCE_FALLBACK, 5000)
}

function useIsRetailUser(): { isLoading: boolean; isRetail: boolean } {
  const applications = useSelector((state: IAppState) => state.userProfile.data?.applications)
  const groups = useSelector((state: IAppState) => state.profile.data?.groups)
  const isEndUser =
    groups !== undefined &&
    Array.isArray(groups) &&
    groups.length > 0 &&
    groups.every((g) => g.name === 'ol_end_user')
  if (isEndUser) return { isLoading: false, isRetail: false }
  if (groups === undefined || applications === undefined) return { isLoading: true, isRetail: false }
  return { isLoading: false, isRetail: applications.some((app) => app.is_retail === true) }
}

const ENTITLEMENT_PARAMS = { disableHashNavigation: true }
const CART_PARAMS = { disableHashNavigation: true }

function useOneloginMfeSession() {
  useEffect(() => {
    sessionStorage.setItem(ONELOGIN_MFE_SESSION_KEY, ONELOGIN_MFE_SESSION_VALUE)
  }, [])
}

let minicartInitDomain: string | null = null

export const openMiniCart = (): void => {
  window.dispatchEvent(new CustomEvent('mfe:openMinicart', { detail: { openDrawer: true } }))
}

export const MiniCart = () => {
  const ecommerceDomain = useEcommerceDomain()
  useOneloginMfeSession()

  useEffect(() => {
    if (!ecommerceDomain || minicartInitDomain === ecommerceDomain) return
    minicartInitDomain = ecommerceDomain
    window.dcSpaMicroFrontendLoader?.init([
      {
        containerId: 'minicart',
        microAppName: 'minicart',
        manifestDomain: ecommerceDomain,
        disableHashNavigation: true,
        disableLoader: true,
      },
    ])
  }, [ecommerceDomain])

  return <div id="minicart" />
}

export const BillingAndSubscription = () => {
  const ecommerceDomain = useEcommerceDomain()
  const { isLoading, isRetail } = useIsRetailUser()
  useOneloginMfeSession()

  if (isLoading) return <Spinner />
  if (!isRetail) return <PageNotFound />
  return (
    <MfRouteComponentLoader
      containerId="digicart"
      microAppName="entitlement"
      manifestDomain={ecommerceDomain}
      additionalParams={ENTITLEMENT_PARAMS}
    />
  )
}

export const Cart = () => {
  const ecommerceDomain = useEcommerceDomain()
  const { isLoading, isRetail } = useIsRetailUser()
  useOneloginMfeSession()

  if (isLoading) return <Spinner />
  if (!isRetail) return <PageNotFound />
  return (
    <MfRouteComponentLoader
      containerId="cart"
      microAppName="cart"
      manifestDomain={ecommerceDomain}
      additionalParams={CART_PARAMS}
    />
  )
}
